import { render, staticRenderFns } from "./security.vue?vue&type=template&id=38d232e3"
import script from "./security.vue?vue&type=script&lang=js"
export * from "./security.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports